import {
  GET_SCHEME_LIST,
  GET_SCHEME_LIST_SUCCESS,
  GET_SCHEME_LIST_FAIL,
  GET_SCHEMENAME,
  GET_SCHEMENAME_SUCCESS,
  GET_SCHEMENAME_FAIL,
  GET_SCHEMEANALYTE,
  GET_SCHEMEANALYTE_SUCCESS,
  GET_SCHEMEANALYTE_FAIL,
  ADD_NEW_SCHEME_LIST,
  ADD_NEW_SCHEME_LIST_SUCCESS,
  ADD_NEW_SCHEME_LIST_FAIL,
  UPDATE_NEW_SCHEME_LIST,
  UPDATE_NEW_SCHEME_LIST_SUCCESS,
  UPDATE_NEW_SCHEME_LIST_FAIL,
  DELETE_SCHEME,
  DELETE_SCHEME_SUCCESS,
  DELETE_SCHEME_FAIL,
  GET_PURCHASED_SCHEME,
  GET_PURCHASED_SCHEME_SUCCESS,
  GET_PURCHASED_SCHEME_FAIL,
  GET_COA_CRITERIA_LIST,
  GET_COA_CRITERIA_LIST_SUCCESS,
  GET_COA_CRITERIA_LIST_FAIL,
  SUBMIT_COA_PARTICIPANTS,
  SUBMIT_COA_PARTICIPANTS_SUCCESS,
  SUBMIT_COA_PARTICIPANTS_FAIL,
  GET_COA_SUBMITTED_LIST,
  GET_COA_SUBMITTED_LIST_SUCCESS,
  GET_COA_SUBMITTED_LIST_FAIL,
  GET_STOCK_LIST,
  GET_STOCK_LIST_SUCCESS,
  GET_STOCK_LIST_FAIL,
  ADD_STOCK,
  ADD_STOCK_SUCCESS,
  ADD_STOCK_FAIL,
  UPDATE_STOCK,
  UPDATE_STOCK_SUCCESS,
  UPDATE_STOCK_FAIL,
} from "./actionTypes";

//////////////Scheme////////////
export const getSchemelist = (id) => ({
  type: GET_SCHEME_LIST,
  payload: id,
  payload: id,
});

export const getSchemelistSuccess = (MethodList) => {
  console.log("MethodList response in success action:", MethodList);
  return {
    type: GET_SCHEME_LIST_SUCCESS,
    payload: MethodList,
  };
};

export const getSchemelistFail = (error) => {
  console.log("Error response in fail action:", error);
  return {
    type: GET_SCHEME_LIST_FAIL,
    payload: error,
  };
};
///get analytes associated with unit
export const getSchemeAnalyte = (id) => ({
  type: GET_SCHEMEANALYTE,
  payload: id,
});

export const getSchemeAnalyteSuccess = (SchemeAnalyte) => ({
  type: GET_SCHEMEANALYTE_SUCCESS,
  payload: SchemeAnalyte,
});

export const getSchemeAnalyteFail = (error) => ({
  type: GET_SCHEMEANALYTE_FAIL,
  payload: error,
});

///get analytes associated with unit
export const getSchemeName = (id) => ({
  type: GET_SCHEMENAME,
  payload: id,
});

export const getSchemeNameSuccess = (UnitAnalyte) => ({
  type: GET_SCHEMENAME_SUCCESS,
  payload: UnitAnalyte,
});

export const getSchemeNameFail = (error) => ({
  type: GET_SCHEMENAME_FAIL,
  payload: error,
});

//////////////Add New Scheme////////////
export const addNewSchemeList = (createUnit, id) => ({
  type: ADD_NEW_SCHEME_LIST,
  payload: { createUnit, id },
});

export const addNewSchemeListSuccess = (createUnit) => ({
  type: ADD_NEW_SCHEME_LIST_SUCCESS,
  payload: createUnit,
});

export const addNewSchemeListFail = (error) => ({
  type: ADD_NEW_SCHEME_LIST_FAIL,
  payload: error,
});

//////////////Update Scheme////////////
export const updateSchemeList = (unit) => ({
  type: UPDATE_NEW_SCHEME_LIST,
  payload: unit,
});

export const updateSchemeListSuccess = (unit) => ({
  type: UPDATE_NEW_SCHEME_LIST_SUCCESS,
  payload: unit,
});

export const updateSchemeListFail = (error) => ({
  type: UPDATE_NEW_SCHEME_LIST_FAIL,
  payload: error,
});

export const deleteScheme = (id) => ({
  type: DELETE_SCHEME,
  payload: id,
});

export const deleteSchemeSuccess = (id) => ({
  type: DELETE_SCHEME_SUCCESS,
  payload: id,
});

export const deleteSchemeFail = (error) => ({
  type: DELETE_SCHEME_FAIL,
  payload: error,
});
export const getPurchasedSchemelist = (id) => ({
  type: GET_PURCHASED_SCHEME,
  payload: id,
});

export const getPurchasedSchemelistSuccess = (payload) => ({
  type: GET_PURCHASED_SCHEME_SUCCESS,
  payload,
});

export const getPurchasedSchemelistFail = (error) => ({
  type: GET_PURCHASED_SCHEME_FAIL,
  payload: error,
});
export const COACriterialist = (data) => ({
  type: GET_COA_CRITERIA_LIST,
  payload: data,
});

export const COACriterialistSuccess = (MethodList) => {
  console.log("MethodList response in success action:", MethodList);
  return {
    type: GET_COA_CRITERIA_LIST_SUCCESS,
    payload: MethodList,
  };
};

export const COACriteriaListFail = (error) => {
  console.log("Error response in fail action:", error);
  return {
    type: GET_COA_CRITERIA_LIST_FAIL,
    payload: error,
  };
};

export const submitCOAParticipants = (payload) => ({
  type: SUBMIT_COA_PARTICIPANTS,
  payload, // { participants: [...] }
});

export const submitCOAParticipantsSuccess = (response) => ({
  type: SUBMIT_COA_PARTICIPANTS_SUCCESS,
  payload: response,
});

export const submitCOAParticipantsFail = (error) => ({
  type: SUBMIT_COA_PARTICIPANTS_FAIL,
  payload: error,
});
export const getCOASubmittedList = (payload) => ({
  type: GET_COA_SUBMITTED_LIST,
  payload, // { scheme_id, cycle_id }
});

export const getCOASubmittedListSuccess = (response) => ({
  type: GET_COA_SUBMITTED_LIST_SUCCESS,
  payload: response,
});

export const getCOASubmittedListFail = (error) => ({
  type: GET_COA_SUBMITTED_LIST_FAIL,
  payload: error,
});

export const getStockList = (id) => ({
  type: GET_STOCK_LIST,
  payload: id,
});

export const getStockListSuccess = (stockList) => ({
  type: GET_STOCK_LIST_SUCCESS,
  payload: stockList,
});

export const getStockListFail = (error) => ({
  type: GET_STOCK_LIST_FAIL,
  payload: error,
});

// Add Stock
export const addStock = (stock, id) => ({
  type: ADD_STOCK,
  payload: { stock, id },
});

export const addStockSuccess = (stock) => ({
  type: ADD_STOCK_SUCCESS,
  payload: stock,
});

export const addStockFail = (error) => ({
  type: ADD_STOCK_FAIL,
  payload: error,
});

// Update Stock
export const updateStock = (stock) => ({
  type: UPDATE_STOCK,
  payload: stock,
});

export const updateStockSuccess = (stock) => ({
  type: UPDATE_STOCK_SUCCESS,
  payload: stock,
});

export const updateStockFail = (error) => ({
  type: UPDATE_STOCK_FAIL,
  payload: error,
});
